import { render, staticRenderFns } from "./NetUpSimCards.vue?vue&type=template&id=7932819e&"
import script from "./NetUpSimCards.vue?vue&type=script&lang=js&"
export * from "./NetUpSimCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports